/* =============================================
   BACKPACKER — Move unavailable swatches to end
   ============================================= */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-form__controls-group').forEach(function (group) {
    const disabled = [];
    const enabled = [];

    group.querySelectorAll('input[type="radio"]').forEach(function (input) {
      const label = input.nextElementSibling;
      if (!label) return;

      if (input.disabled || input.classList.contains('disabled')) {
        disabled.push({ input, label });
      } else {
        enabled.push({ input, label });
      }
    });

    [...enabled, ...disabled].forEach(function ({ input, label }) {
      group.appendChild(input);
      group.appendChild(label);
    });
  });
});